import {toast} from "react-toastify";

export const handleXErrorMessage = (message) => {
    switch (message) {
        case 'POLICY_NUMBER_ALREADY_EXISTS':
            toast.error('Policy number already exists');
            break;
        case 'PASSWORD_EXPIRED':
            toast.error('Your password has expired. Passwords must be changed every 90 days.');
            if (typeof window !== 'undefined' && !window.location.pathname.includes('/reset-password')) {
                window.location.href = '/reset-password?expired=true';
            }
            break;
        default:
            console.log(`GraphQL error: ${message}`);
            break;
    }
}